/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

/**
 * @description Réponse contenant un message simple
 */
export const messageResponseSchema = z.object({
      "message": z.string().describe("Message de la réponse").optional()
      }).describe("Réponse contenant un message simple")